module.exports = __webpack_public_path__ + "img/portugal-digestive-diseases-female.08c79b2d.png";